import { supabase } from '@/lib/supabaseClient';
import type { ContactFormData, ContactSubmission } from '@/types/contact';

function formatDateForPostgres(dateStr: string): string {
  // Convert from DD-MM-YYYY to YYYY-MM-DD
  const [day, month, year] = dateStr.split('-');
  return `${year}-${month}-${day}`;
}

export const contactService = {
  async submitForm(formData: ContactFormData): Promise<ContactSubmission> {
    // Format the date for PostgreSQL
    const formattedData = {
      ...formData,
      wedding_date: formatDateForPostgres(formData.wedding_date)
    };

    const { data, error } = await supabase
      .from('contact_submissions')
      .insert([formattedData])
      .select()
      .single();

    if (error) {
      console.error('Error submitting form:', error);
      throw new Error('Failed to submit form');
    }

    return data;
  },

  async getSubmissionByEmail(email: string): Promise<ContactSubmission | null> {
    const { data, error } = await supabase
      .from('contact_submissions')
      .select()
      .eq('email', email)
      .single();

    if (error) {
      console.error('Error fetching submission:', error);
      return null;
    }

    return data;
  }
}; 